import { render, staticRenderFns } from "./RollingStock.vue?vue&type=template&id=2947500d"
import script from "./RollingStock.vue?vue&type=script&lang=js"
export * from "./RollingStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports